const getActiveCampaignBanner = (banner, { globalStoreId }) => {
  if (!banner) {
    return;
  }
  if (!banner?.startDate || !banner?.endDate) {
    return;
  }
  if (!(Date.now() > banner.startDate && Date.now() < banner.endDate)) {
    return;
  }
  if (!banner.storesList) {
    return { url: banner.url, description: banner.description };
  }
  const list = banner.storesList.split(",").map((item) => item.replace(/\s/g, ""));
  const found = list?.find((item) => item === globalStoreId);
  if (found !== globalStoreId) {
    return;
  }
  return {
    url: banner.url,
    description: banner.description
  };
};
export {
  getActiveCampaignBanner
};
//# sourceMappingURL=get-active-campaign-banner.js.map
